import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Domain } from "../models/Domain";
import { Pagination } from "../../../models/Pagination";
import { IPaginationQuery } from "../../../hooks/usePagination";
import { useStoredDomain } from "./useStoredDomain";

interface IUseDomains {
  params?: {
    search?: string;
  } & IPaginationQuery;
}

export const useDomains = ({ params }: IUseDomains = {}) => {
  const { page = 1, search = "", per_page = 10, ...rest } = params || {};

  const selectedDomain = useStoredDomain();
  const domainId = selectedDomain?.id ?? null;

  const fetch = useFetch<Domain[]>("/api/domains", {
    initialData: [],
    params: {
      page,
      per_page,
      ...rest,
      search: domainId ?? search,
    },
  });

  const { fetchData, refetch } = fetch;

  const fetchDataCustom = async (override?: {
    params?: Record<string, any>;
  }) => {
    fetchData({
      ...override,
      params: { ...override?.params, search: domainId ?? search },
    });
  };

  const refetchCustom = async (override?: { params?: Record<string, any> }) => {
    refetch({
      ...override,
      params: { ...override?.params, search: domainId ?? search },
    });
  };

  return {
    fetch: {
      ...fetch,
      fetchData: fetchDataCustom,
      refetch: refetchCustom,
    },
    pagination: new Pagination(fetch.meta),
  };
};
